import { registerComponent } from '../../lib/vulcan-lib/components';
import React from 'react';
import CollectionsPage from "./CollectionsPage";

const SequencesHighlightsCollection = () => {
  return <CollectionsPage documentId={'62bf5f5dc581cd211cc67d49'} />
};

export default registerComponent('SequencesHighlightsCollection', SequencesHighlightsCollection);



